export default __webpack_public_path__ + "static/media/LeaveCommunity.6810a273.svg";